export const DISCOUNT_NAME_PREFIX = 'LAVA: ';

export function addDiscountNamePrefix(discountName: string) {
  return DISCOUNT_NAME_PREFIX + discountName;
}

export function removeDiscountNamePrefix(discountName: string) {
  if (discountName.startsWith(DISCOUNT_NAME_PREFIX)) {
    return discountName.slice(DISCOUNT_NAME_PREFIX.length);
  }

  return discountName;
}
